(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.ucwsDropdownFilters = {

    attach: function (context, settings) {

      var $blocks = $('.block.views-block.dropdown-filters');
      $blocks.each(function () {

        // Enable Bootstrap Select for each select field (except pagination).
        var $bootstrapSelect = $('select:not(.bootstrap-select)', $(this)).not(':hidden');
        if ($bootstrapSelect.length > 0) {
          $bootstrapSelect.each(function () {
            var liveSearchEnabled = ($('option', $(this)).length >= 20) ? true : false;
            var dropupAutoEnabled = false; // Opening upward conflicts with the header!
            $(this)
              .addClass('bootstrap-select selectpicker')
              .selectpicker({
                liveSearch: liveSearchEnabled,
                dropupAuto: dropupAutoEnabled,
                liveSearchPlaceholder: 'Search'
              });
          });
        }
      });
    }
  };
})(jQuery, Drupal);
